import script from "./SaleHistoryCard.vue?vue&type=script&setup=true&lang=js"
export * from "./SaleHistoryCard.vue?vue&type=script&setup=true&lang=js"

import "./SaleHistoryCard.vue?vue&type=style&index=0&id=ba700c5c&scoped=true&lang=postcss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ba700c5c"]])

export default __exports__